export const api = {

    // login
    login: "admin/send_otp",
    verifyOtp: "admin/verify_otp",

    //Layouts
    getAvailableAccess: "admin/get_available_access",

    // image
    uploadImage: "upload/image",
    deleteFile: "upload/delete_file",

    // add member
    addMember: "admin/add_member",
    getMember: "admin/get_member",
    getLocationByPincode: 'admin/getLocationByPincode',

    // ------------------ Settings ------------------
    getForm: "admin/form",
    createFields: "admin/fields/create",
    deleteFields: "admin/fields/delete",
    updateFields: "admin/fields/update",
    getDataById: "admin/forms_by_key",

    // Role & Permissions
    get_dynamic_role_list: "admin/get_dynamic_role_list",
    get_user_list: "admin/get_user_list",
    inactive_user_list: "admin/inactive_user_list",
    add_extra_userType: "admin/add_extra_userType",
    // delete_extra_userType: "admin/delete_extra_userType",
    active_inactive_member: "admin/remove_extra_userType",
    active_inactive_member_Deactive: "admin/active_inactive_member",

    //FAQ
    getFaqs: "admin/faq/get",
    addFaqs: "admin/faq",
    updateFaqs: "admin/faq",
    deleteFaqs: "admin/faq",

    //Account
    getAccount: "admin/delete_reason/get",
    addAccount: "admin/delete_reason",
    updateAccount: "admin/delete_reason",
    deleteAccount: "admin/delete_reason",

    //Stage Of Claims
    getStage: "admin/stage",
    addStage: "admin/stage",
    updateStage: "admin/stage",
    deleteStage: "admin/stage",

    //Documents
    getDocuments: "admin/get_members",
    verifyDocuments: "user/update_sahaynidhi",
    getDocumentsById: "admin/get_member",
    updateMember: "admin/update_member",
    getMembersSummary: "admin/get_members_summary",

    // User & Role
    add_role_access: "admin/add_role_access",
    get_role_access: "admin/get_role_access",
    update_role_access: "admin/update_role_access",
    get_available_access: "admin/get_available_access",

    // Banner
    getBanner: "admin/banner/get",
    addBanner: "admin/banner",
    updateBanner: "admin/banner",
    deleteBanner: "admin/banner/",

    // Occupation
    getOccupation: "admin/occupation/get",
    addOccupation: "admin/occupation",
    updateOccupation: "admin/occupation",
    deleteOccupation: "admin/occupation",

    // App Version
    getAppVersion: "admin/appVersion/get?platformType=",
    updateAppVersion: "admin/appUpdateVersion",

    // App Role & Permission 
    update_application_role_permission: "admin/update_application_role_permission",

    //General Notfication
    // ---> Notification
    getNotifications: "admin/notification/get",
    addNotifications: "admin/notification",
    updateNotifications: "admin/notification",
    deleteNotifications: "admin/notification/",

    // follwUp 
    get_all_followups: "admin/get_all_followups",
    update_followup: "admin/update_followup",
    getDocumentAssigneeRoles: "admin/getDocumentAssigneeRoles",
    assignMember: "admin/assignMember",

    // getTransactionHistory
    getTransactionHistory: "admin/get_user_transaction_history",
    getParticularUserTransaction: "admin/get_user_all_transaction_status_history",
    get_transaction_list: "admin/get_transaction_list",

    // get_member_by_mobileNumber
    getMemberByMobileNumber: "admin/get_member_by_mobileNumber",


    addRole: "admin/add_role",

    app_get_role_access: "admin/app_get_role_access",
    app_update_role_access: "admin/app_update_role_access",

    get_company_member_list: "admin/get_company_member_list",
    get_company_members_summary: "admin/get_company_members_summary",
    update_company_member: "admin/update_company_member",

    get_organisation_payment_request  : "admin/get_organisation_payment_request",
    approve_organisation_paymentRequest : "admin/approve_organisation_paymentRequest",
    create_organisation_paymentRequest : "admin/create_organisation_paymentRequest",
    add_user_transaction : "admin/add_user_transaction",
    aadhar_send_otp : "admin/aadhar_send_otp",
    aadhar_verify_otp : "admin/aadhar_verify_otp",
    id_proof_verification : "admin/id_proof_verification",
    get_payment_receipt : "admin/get_payment_receipt",
    api_config : "admin/api_config",
    update_config : "admin/update_config",
    create_posts : "admin/create_posts",
    get_posts : "admin/get_posts",
    delete_post : "admin/delete_post",
    update_post : "admin/update_post",
    createPrivacyPolicyAndTermsAndCondition : "admin/createPrivacyPolicyAndTermsAndCondition",
    getPrivacyPolicyAndTermsAndCondition : "admin/getPrivacyPolicyAndTermsAndCondition",
    get_contactUs : "admin/get_contactUs",
    delete_contactUs : "admin/delete_contactUs",
    updatePrivacyPolicyAndTermsAndCondition : "admin/updatePrivacyPolicyAndTermsAndCondition",
    getMemberByPhoneNumber : "admin/getMemberByPhoneNumber",
    getTicket : "admin/getTicket",
    deleteTicket : "admin/deleteTicket",
    getAllEligibleMembers : "admin/getAllEligibleMembers",
    getAllClaims : "admin/getAllClaims",
    updateClaim : "admin/updateClaim",
    createaboutUs : "admin/createaboutUs",
    updateaboutUs : "admin/updateaboutUs",
    getallaboutUs : "admin/getallaboutUs",
    getallpressandmediacoverage : "admin/getallpressandmediacoverage",
    createpressandmediacoverage : "admin/createpressandmediacoverage",
    updatepressandmediacoverage : "admin/updatepressandmediacoverage",
    getallpress : "admin/getallpress",
    createpress : "admin/createpress",
    updatepress : "admin/updatepress",
    deletepress : "admin/deletepress",
};